import { Swiper, Navigation, Pagination, Autoplay, Mousewheel } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay, Mousewheel]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    let bannerHome = new Swiper(".banner__slider", {
        watchOverflow: true,
        pagination: {
            el: ".banner__pagination",
            type: "bullets",
            clickable: true,
        },
        autoplay: {
            delay: 5000,
        },
    });

    let articles = new Swiper(".articles__listing", { 
        slidesPerView: 6,
        spaceBetween: 20,
        watchOverflow: true,
        direction: "vertical",
        mousewheel: true,
        navigation: {
            nextEl: ".articles__btn-next",
        },
    });

    let enterprisesSlides = new Swiper(".enterprises__swiper", {
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        },
    });

    let detailsSlides = new Swiper(".details__slide", {
        navigation: {
            nextEl: ".details__next",
            prevEl: ".details__prev",
        },
    });
    
    let galleryModalSlider = new Swiper(".gallery__slider", {
        slidesPerView: 1,
        navigation: {
            nextEl: ".gallery__next",
            prevEl: ".gallery__prev",
        },
    });
};
